import React from "react"
import ActionWrapper from "containers/ActionWrapper"
import WithData from "containers/WithData"
import Loaded from "./CampInfoRequests"
import Loading from "./CampInfoRequests.loading"
import glamorous from "glamorous"
import style from "utils/style"

class CampInfoRequests extends React.Component {
  render() {
    let archived = this.props.match.params.filter === "archived" ? true : false

    return (
      <ActionWrapper title="Information Requests">
        <WithData
          route={`info_requests?include=user,campers&filter[archived]=${archived}`}
          LoadingComponent={Loading}
        >
          <Loaded />
        </WithData>
      </ActionWrapper>
    )
  }
}

export default CampInfoRequests

export const ArchiveRequest = glamorous.button({
  background: style.colors.reddishOrange,
  fontSize: "0.8rem",
  color: "white",
  border: `1px solid ${style.colors.darkRed}`,
  borderRadius: 5,
  padding: 5,
  "&:hover": {
    cursor: "pointer",
  },
})

export const EmailUserButton = glamorous.button({
  background: "white",
  fontSize: "0.8rem",
  color: "black",
  border: `1px solid ${style.colors.darkRed}`,
  borderRadius: 5,
  padding: 5,
  "&:hover": {
    cursor: "pointer",
  },
})



// WEBPACK FOOTER //
// ./src/scenes/Camp/CampInfoRequests/index.js